import { ThemeType } from '../enums';

export const KIOSK_DEVICE_PROFILE = {
  BRAND_COLOR: '#7c4dff',
  HEADER_COLOR: '#7c4dff',
  THEME: ThemeType.LIGHT,
};
